import { Link } from 'react-router-dom';

const PRODUCT_LINKS = [
  { label: 'Features', href: '#features' },
  { label: 'How it works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Sign up', to: '/signup' },
  { label: 'Sign in', to: '/signin' },
];

const LEGAL_LINKS = [
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
  { label: 'Disclaimer', to: '/disclaimer' },
];

export default function LandingFooter() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#3A1A0E' }} data-testid="landing-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <img src="/brand/logo-round.png" alt="" className="w-8 h-8 rounded-full" />
              <span className="text-lg font-extrabold" style={{ color: '#FBF6EF' }}>Heritage Compass</span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: '#C4A98C' }}>
              Medications, made clear.
            </p>
          </div>

          {/* Product */}
          <div>
            <p className="text-xs font-extrabold uppercase tracking-widest mb-3" style={{ color: '#C4A98C' }}>Product</p>
            <ul className="space-y-2">
              {PRODUCT_LINKS.map((l) =>
                l.to ? (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm hover:underline" style={{ color: '#FBF6EF' }}>{l.label}</Link>
                  </li>
                ) : (
                  <li key={l.label}>
                    <a href={l.href} onClick={(e) => scrollTo(e, l.href)} className="text-sm hover:underline" style={{ color: '#FBF6EF' }}>{l.label}</a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-extrabold uppercase tracking-widest mb-3" style={{ color: '#C4A98C' }}>Legal</p>
            <ul className="space-y-2">
              {LEGAL_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm hover:underline" style={{ color: '#FBF6EF' }}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t py-4" style={{ borderColor: '#5B2D1F' }}>
        <p className="text-xs text-center" style={{ color: '#8B7A6B' }}>
          &copy; 2026 Heritage Compass. Not affiliated with any healthcare provider. Educational use only.
        </p>
      </div>
    </footer>
  );
}
